import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Radio, RadioGroup } from 'react-radio-group';
import { colors } from '_styles';
import {
  useForm,
  FormProvider,
} from 'react-hook-form';
import { _ } from '_locales';

import { ConfirmToExport, OutlookExportModal } from './components';
import store from '../../configureStore';

// style
const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const ExportContainer = styled.div`
  width: 100%;
  height: auto;
  overflow: hidden;
  box-sizing: border-box;
  padding: 10px 25px;
  font-weight: 500 !important;
`;

const CalTypeList = styled.div`
  position: relative;
  padding: 1.2em 0px;
  font-weight: normal !important;
  color: #717171;
  text-shadow: 0 1px 1px #fff;
  display: flex;
  flex-wrap: wrap;

  ${(parentWidth < 431) && css`
    display: block;
  `};
`;

const RadioButtonContainer = styled.fieldset`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
  border: none;

  & input {
    margin-right: 5px;
    margin-left: 15px;
    transform: scale(1.5);
    accent-color: ${colors.RC_ACTION};
    cursor: pointer;
  }
  span {
    display: inline-block;
    font-size: 16px;
    font-weight: 400 !important;
    margin: 10px;
  }
  `;

const Item = styled.span`
  font-family: Roboto, sans-serif !important;
`;
const TextHeader = styled.legend`
  margin: 10px 0 10px 0 !important;
  font-size: 16px !important;
  color: #000000 !important;
  font-family: Roboto, sans-serif !important;
  width: 100%;
  line-height: 1.5em;
`;
const TextHeaderBold = styled(TextHeader)`
  font-weight: 600;
  line-height: initial;
`;

const ConfirmToExportContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 20px;
`;

const RadioButtonLabel = styled.label`
  color: #000000;
  cursor: pointer;
`;

/**
 * This component is for sync the collections that you selected to your preferred calendar
 *
 * @author Alireza Zebardast
 * @param {object} plugin
 * @param {object} config
 */
const ExportCalendar = ({ plugin, config }) => {
  const { projectId } = plugin;
  const { districtId, collection } = config;
  const state = store.store.getState();
  const { zoneStr } = state.zone;

  const [colObject, setColObject] = useState(
    collection
      && Object.keys(collection).length
      ? new Array(Object.keys(collection).length).fill('') : ''
  );
  const [calType, setCalType] = useState('');
  const [colStr, setColStr] = useState('');

  const methods = useForm();

  useEffect(() => {
    if (collection && Object.keys(collection).length) {
      const collectionObject = [];
      let collTitleString = '';
      // eslint-disable-next-line array-callback-return
      Object.keys(collection).map((res, index) => {
        const id = `${index}@${res}@${collection[res].schedule}`;
        const [idx, result, schedule] = id.split('@');
        const mergedCollTitle = `${result}-${schedule}`;
        collectionObject[idx] = { [idx]: true, collTitle: mergedCollTitle };
      });

      for (let i = 0; i < collectionObject.length; i += 1) {
        if (
          collectionObject[i] !== ''
          && collectionObject[i][i]
        ) {
          collTitleString += `${collectionObject[i].collTitle}-`;
        }
      }
      setColStr(collTitleString.slice(0, -1));
      setColObject(collectionObject);
    }
  }, [collection]);

  const calOptions = [
    {
      value: 'iCal',
      label: _('cal.ical'),
    },
    {
      value: 'OutLook',
      label: _('cal.outLook'),
    },
    {
      value: 'Google_Calendar',
      label: _('cal.google_calendar'),
    },
    {
      value: 'Other',
      label: _('cal.other'),
    },
  ];

  const changeHandler = (value) => {
    setCalType(value);
  };

  return (
    <div>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <FormProvider {...methods}>
        <ExportContainer>
          <RadioGroup
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginLeft: 10,
            }}
            selectedValue={calType}
            onChange={changeHandler}
          >
            <RadioButtonContainer>
              <TextHeader>{_('cal.to_have_collection_and_event_daters')}</TextHeader>
              <TextHeaderBold>{_('cal.choose_calendar')}</TextHeaderBold>
              <>
                {calOptions.map((item) => (
                  <RadioButtonLabel htmlFor={item.value}>
                    <Radio
                      value={item.value}
                      id={item.value}
                    />
                    <Item>{item.label}</Item>
                  </RadioButtonLabel>
                ))}
              </>
            </RadioButtonContainer>
          </RadioGroup>

          <CalTypeList>
            <ConfirmToExportContainer>
              <ConfirmToExport
                colStr={colStr}
                calType={calType}
                colObject={colObject}
                projectId={projectId}
                districtId={districtId}
                zoneStr={zoneStr}
              />
            </ConfirmToExportContainer>
          </CalTypeList>

        </ExportContainer>
      </FormProvider>
    </div>
  );
};

export default ExportCalendar;
